import { render, staticRenderFns } from "./UserRevocationDetail.vue?vue&type=template&id=72d20dd0&scoped=true"
import script from "./UserRevocationDetail.vue?vue&type=script&lang=js"
export * from "./UserRevocationDetail.vue?vue&type=script&lang=js"
import style0 from "./UserRevocationDetail.vue?vue&type=style&index=0&id=72d20dd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d20dd0",
  null
  
)

export default component.exports